import { defineSlotRecipe } from "@chakra-ui/react";
import { accordionAnatomy } from "@chakra-ui/react/anatomy";

// Restores the Chakra v2 accordion padding.
const accordionRecipe = defineSlotRecipe({
  slots: accordionAnatomy.keys(),
  base: {
    itemTrigger: {
      px: "4",
      gap: "0",
      _hover: {
        bg: "blackAlpha.50",
      },
    },
    itemContent: {
      px: "4",
    },
    itemBody: {
      pt: "2",
      pb: "0",
    },
  },
});

export default accordionRecipe;
